/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Browse_SeedsInputs */

const en_browse_seeds = /** @type {(inputs: Browse_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse seeds`)
};

const th_browse_seeds = /** @type {(inputs: Browse_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เลือกดูเมล็ดพันธุ์`)
};

const ja_browse_seeds = /** @type {(inputs: Browse_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シードを見る`)
};

const fr_browse_seeds = /** @type {(inputs: Browse_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parcourir les graines`)
};

const es_browse_seeds = /** @type {(inputs: Browse_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver semillas`)
};

const ru_browse_seeds = /** @type {(inputs: Browse_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смотреть семена`)
};

const zh_browse_seeds = /** @type {(inputs: Browse_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览种子`)
};

const vi_browse_seeds = /** @type {(inputs: Browse_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem hạt giống`)
};

/**
* | output |
* | --- |
* | "Browse seeds" |
*
* @param {Browse_SeedsInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const browse_seeds = /** @type {((inputs?: Browse_SeedsInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Browse_SeedsInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_browse_seeds(inputs)
	if (locale === "ja") return ja_browse_seeds(inputs)
	if (locale === "fr") return fr_browse_seeds(inputs)
	if (locale === "es") return es_browse_seeds(inputs)
	if (locale === "ru") return ru_browse_seeds(inputs)
	if (locale === "zh") return zh_browse_seeds(inputs)
	if (locale === "vi") return vi_browse_seeds(inputs)
	return en_browse_seeds(inputs)
});